import React, { Component } from 'react';
import PropTypes from 'prop-types';

class BlogFilterBar extends Component {
  constructor(props) {
    super(props);
    this.dropDownClickHandler = this.dropDownClickHandler.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.dropDownClickHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.dropDownClickHandler);
  }

  dropDownClickHandler(event) {
    if (
      event.target.closest('.dropdown-menu')
      || event.target.closest('.dropdown-toggle')
    ) {
      return;
    }

    this.props.closeAllDropdowns(event);
  }

  renderFilterDropdown(filter) {
    const { buttonClick, filterClick } = this.props;

    return (
      <div key={filter.name} className={`dropdown${filter.active ? ' show' : ''}`}>
        <button
          type="button"
          className={`btn btn-teal-25 dropdown-toggle rounded-pill py-1 px-3${filter.active ? ' show' : ''}`}
          aria-expanded={filter.active}
          onClick={event => buttonClick(event, filter.name)}
        >
          {filter.name}
        </button>
        <div
          className={`dropdown-menu overflow-y-auto p-3${filter.active ? ' show' : ''}`}
          style={{ minWidth: '250px' }}
        >
          {filter.options.map(option => (
            <div key={option.name} className="form-check">
              <input
                className="form-check-input filter-option"
                type="checkbox"
                id={`blog-filter-${option.inputName}`}
                checked={option.isChecked === true}
                onChange={() => filterClick(option)}
              />
              <label className="form-check-label" htmlFor={`blog-filter-${option.inputName}`}>
                {option.name}
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  }

  render() {
    const { filters, showClearAll, clearFilters } = this.props;
    const filterItems = Object.keys(filters)
      .filter(key => typeof filters[key] !== 'string')
      .sort((keyA, keyB) => filters[keyA].order - filters[keyB].order)
      .map(key => filters[key]);

    return (
      <div className="d-flex flex-wrap align-items-center gap-3 blog-filter-dropdowns">
        {filterItems.map(filter => this.renderFilterDropdown(filter))}
        {showClearAll ? (
          <button
            type="button"
            className="btn btn-link text-dark text-decoration-underline p-0 border-0 blog-clear-filters text-nowrap fw-normal lh-base"
            onClick={() => clearFilters()}
          >
            Clear All
          </button>
        ) : null}
      </div>
    );
  }
}

BlogFilterBar.defaultProps = {
  showClearAll: false,
};

BlogFilterBar.propTypes = {
  buttonClick: PropTypes.func.isRequired,
  closeAllDropdowns: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  showClearAll: PropTypes.bool,
  filters: PropTypes.shape(PropTypes.object),
};

export default BlogFilterBar;
